<template>
  <div class="modal csiteMenuModal reporterDetailModal authenAreaModal" id="surveyMenuInfoNoPermissionModal" tabindex="-1" aria-labelledby="surveyMenuInfoNoPermissionModalLabel" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content coinModalDetailArea">
        <button type="button" class="btnClose" data-bs-dismiss="modal" aria-label="Close">
          <svg class="svg-inline--fa fa-circle-xmark" aria-hidden="true" focusable="false"
            data-prefix="fas" data-icon="circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512">
            <path class="" fill="currentColor"
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
            </path>
          </svg>
        </button>
        <div class="modal-body">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYKA9AAgwAABkAAEodompAAAAAElFTkSuQmCC"
            class="w-100 mb-3 imgBg"
            :style="{ backgroundImage: `url(${menuData?.thumbnail?.url})` }">
          <h4>{{ menuData?.name }}</h4>
        </div>
        <!-- {{ menuData }} -->
        <div class="modal-footer d-flex justify-content-between" v-if="menuData?.btn">
          <div v-if="menuData?.btn?.zone1?.btnStatus === 1">
            <button
              type="button"
              class="btn"
              :style="{ color: menuData?.btn?.zone1?.btnColor, backgroundColor: menuData?.btn?.zone1?.bgColor }"
              @click="goto(menuData?.btn?.zone1?.btnURL)"
            >
              <font-awesome-icon
                :icon="menuData?.btn?.zone1?.btnIcon.split(' ')"
                class="me-2"
              />
                {{ menuData?.btn?.zone1?.btnName }}
            </button>
          </div>
          <div v-if="menuData?.btn?.zone2?.btnStatus === 1">
            <button
              type="button"
              class="btn"
              :style="{ color: menuData?.btn?.zone2?.btnColor, backgroundColor: menuData?.btn?.zone2?.bgColor }"
              @click="goto(menuData?.btn?.zone2?.btnURL)"
            >
              <font-awesome-icon
                :icon="menuData?.btn?.zone2?.btnIcon.split(' ')"
                class="me-2"
              />
                {{ menuData?.btn?.zone2?.btnName }}
            </button>
          </div>
          <div v-if="menuData?.btn?.zone3?.btnStatus === 1">
            <button
              type="button"
              class="btn"
              :style="{ color: menuData?.btn?.zone3?.btnColor, backgroundColor: menuData?.btn?.zone3?.bgColor }"
              @click="goto(menuData?.btn?.zone3?.btnURL)"
            >
              <font-awesome-icon
                :icon="menuData?.btn?.zone3?.btnIcon.split(' ')"
                class="me-2"
              />
                {{ menuData?.btn?.zone3?.btnName }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// import zone
import { onMounted, ref } from 'vue';
import eventBus from '@/eventBus/eventBus.js';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

// variable zone
const baseURL = window.location.origin;
const store = useStore();
const router = useRouter();
const surveyMenuInfoModal = ref(null);
const menuData = ref(null);

// end valiable zone

const showModal= () => {
  if (!surveyMenuInfoModal.value) {
    surveyMenuInfoModal.value = new bootstrap.Modal(document.getElementById('surveyMenuInfoNoPermissionModal'), {});
  }
  surveyMenuInfoModal.value.show();
};

const hideModal = () => {
  if (surveyMenuInfoModal.value) {
    surveyMenuInfoModal.value.hide();
  }
};

const setupData = async (data) => {
  menuData.value = data;
  showModal();
};

const goto = (routeName) => {
  if (routeName) {
    const fullPath = `${baseURL}/${routeName}`;
    hideModal();
    window.location.href = fullPath;
    // router.push({ name: routeName });
  }
};
// end function zone

onMounted(() => {
  surveyMenuInfoModal.value = new bootstrap.Modal(document.getElementById('surveyMenuInfoNoPermissionModal'), {});
  // console.log(window.location.origin);
  eventBus.on('showSurveyMenuInfoNoPermissionModal', (obj) => {
    setupData(obj);
  });

  eventBus.on('hideSurveyMenuInfoNoPermissionModal', () => {
    hideModal();
  });
});

defineExpose({
  showModal,
  hideModal
});
</script>